import React, { Component } from "react";
import InputField from "./Elements/InputField";
import SubmitFeed from "./Elements/SubmitFeed";
import DropZone from "../../../../../../Feeds/AddFeeds/Linkedin/components/dropZone";
import { TOAST_ERROR } from "../../../../../../../../../utils";


class LinkedInFeed extends Component {
    constructor(props) {
        super(props);
        this.state = {
            url: "",
            hashtag: "",
            handle: "",
            companyUrl: "",
            hashtagError: false,
            handleError: false,
            companyUrlError: false,
            error: false,
            loading: false,
            fileName: 'Your selected file name',
            imageUrl: null
        }
    }

    onTextChange = (e) => this.setState({ [e.target.name]: e.target.value, error: false , errorMsg:false , loading:false});

    onUploadSuccess = (fileName, url) => this.setState({ fileName: fileName, imageUrl: url });

    onSubmit = () => {
        const { updateStep, selectedFilterId } = this.props;
        const { url, imageUrl, hashtag, handle, companyUrl } = this.state;

        if (selectedFilterId == 16 && url == '') {
            this.setState({ error: true, errorMsg: 'This field is required' });
        }else if (selectedFilterId == 18 && imageUrl == null) {
            TOAST_ERROR("Please upload a Csv File");
        }else if (selectedFilterId == 1 && handle == '') {
            this.setState({ handleError: true, errorMsg: 'This field is required' });
        }else if (selectedFilterId == 2 && hashtag == '') {
            this.setState({ hashtagError: true, errorMsg: 'This field is required' });
        }else if (selectedFilterId == 17 && companyUrl == '') {
            this.setState({ companyUrlError: true, errorMsg: 'This field is required' });
        } else {
            const obj = {
                networkId: 10,
                filter: selectedFilterId,
                field: selectedFilterId == 16 ? url : selectedFilterId == 1 ? handle : selectedFilterId == 2 ? hashtag.split('#').join('') : selectedFilterId == 17 ? companyUrl.split('/mycompany')[0] : imageUrl,
                moderation: 0
            }
            if((selectedFilterId == 1 || selectedFilterId == 16 || selectedFilterId == 17) && !obj.field.includes('https:')){
                const key = selectedFilterId == 1 ? 'handleError' : selectedFilterId == 17 ? 'companyUrlError' : 'error';
                this.setState({ [key]: true, errorMsg: 'This field must contain a url'  });
                return;
            }

            this.setState({ loading: true, error:false });

            updateStep(2, obj, () => this.setState({ loading: false }));

        }
    }

    render() {
        const { url, error, handle, handleError, hashtag, hashtagError, companyUrl, companyUrlError, fileName, imageUrl, loading, errorMsg } = this.state;
        const { selectedFilterId } = this.props;
        
        return (
            <div className="ob-feed-form-wrapper w-100">
                {selectedFilterId == 1 ? <div className="selectSource-right mb-3">
                    <div className="position-relative advance-input custom-input">
                        <div className="position-relative d-flex">
                            <span className="hastag d-flex align-items-center">
                                <i className={`fas fa-at`}></i>
                            </span>
                            <InputField name={"handle"} placeholder="Enter handle here.." className="form-control p-3" value={handle} onChangeHandler={(e) => this.onTextChange(e)} />
                        </div>
                        {handleError && <span id="feedsslackkeyworderror" className="errorMessage required text-start">{errorMsg}</span>}
                    </div>
                </div> : selectedFilterId == 2 ? <div className="selectSource-right mb-3">
                    <div className="position-relative advance-input custom-input">
                        <div className="position-relative d-flex">
                            <span className="hastag d-flex align-items-center">
                                <i className={`fas fa-hashtag`}></i>
                            </span>
                            <InputField name={"hashtag"} placeholder="Enter hashtag here.." className="form-control p-3" value={hashtag} onChangeHandler={(e) => this.onTextChange(e)} />
                        </div>
                        {hashtagError && <span id="feedsslackkeyworderror" className="errorMessage required text-start">{errorMsg}</span>}
                    </div>
                </div> : selectedFilterId == 17 ? <div className="selectSource-right mb-3">
                    <div className="position-relative advance-input custom-input">
                        <div className="position-relative d-flex">
                            <span className="hastag d-flex align-items-center">
                                <i className={`fas fa-link`}></i>
                            </span>
                            <InputField name={"companyUrl"} placeholder="Enter company URL here.." className="form-control p-3" value={companyUrl} onChangeHandler={(e) => this.onTextChange(e)} />
                        </div>
                        {companyUrlError && <span id="feedsslackkeyworderror" className="errorMessage required text-start">{errorMsg}</span>}
                    </div>
                </div> : selectedFilterId == 16 ? <div className="selectSource-right mb-3">
                    <div className="position-relative advance-input custom-input">
                        <div className="position-relative d-flex">
                            <span className="hastag d-flex align-items-center">
                                <i className={`fas fa-flag`}></i>
                            </span>
                            <InputField name={"url"} placeholder="Enter post URL here.." className="form-control p-3" value={url} onChangeHandler={(e) => this.onTextChange(e)} />
                        </div>
                        {error && <span id="feedsslackkeyworderror" className="errorMessage required text-start">{errorMsg}</span>}
                    </div>
                </div> :
                   <div className="px-3 mb-3">
                        <DropZone onUploadSuccess={this.onUploadSuccess} fileName={fileName} />
                   </div> 
                   }
                <div className="click-next d-flex align-items-center py-3 px-3 rounded justify-content-between">
                    <SubmitFeed loading={loading} onSubmit={this.onSubmit} onBack={this.props.backAction} disabled={selectedFilterId == 1 ? !handle.trim() : selectedFilterId == 2 ? !hashtag.trim() : selectedFilterId == 16 ? !url.trim() : selectedFilterId == 17 ? !companyUrl.trim() : selectedFilterId == 18 ? imageUrl == null : false} />
                </div> 
            </div>
        )
    }
}

export default LinkedInFeed;